import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { YOUTUBE_CHANNEL_VIDEOS_URL } from '../../lib/youtube';
import BrandLogo from './BrandLogo';

type FooterLink = {
  label: string;
  to?: string;
  href?: string;
  accent?: boolean;
};

const footerColumns: { title: string; links: FooterLink[] }[] = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about-us' },
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Book a Call', to: '/book-a-call', accent: true },
    ],
  },
  {
    title: 'Talent',
    links: [
      { label: 'Roles We Fill', to: '/roles-we-fill' },
      { label: 'Industries', to: '/industries' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Retingent Recruitment', to: '/solutions/retingent-recruitment' },
      { label: 'Pipelining Talent Infrastructure', to: '/solutions/pipelining-talent-infrastructure' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Podcasts', to: '/resources#podcasts' },
      { label: 'Blog', to: '/blog' },
    ],
  },
];

function FooterColumn({ title, links }: { title: string; links: FooterLink[] }) {
  return (
    <Col xs={6} md={3} lg className="site-footer__column">
      <p className="site-footer__column-title">{title}</p>
      <ul className="site-footer__links list-unstyled mb-0">
        {links.map((link) => (
          <li key={link.label}>
            {link.to ? (
              <Link
                className={`site-footer__link${link.accent ? ' site-footer__link--accent' : ''}`}
                to={link.to}
              >
                {link.label}
              </Link>
            ) : (
              <a
                className={`site-footer__link${link.accent ? ' site-footer__link--accent' : ''}`}
                href={link.href}
              >
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </Col>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer bg-sbr-navy text-white mt-auto">
      <Container>
        <Row className="site-footer__main gy-5">
          <Col lg={4} xl={3} className="site-footer__brand-col">
            <BrandLogo variant="light" />
            <p className="site-footer__tagline">
              AI-powered precision and human expertise for your hardest-to-fill roles.
            </p>
            <div className="site-footer__social">
              <a
                className="site-footer__social-link"
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin" aria-hidden />
              </a>
              <a
                className="site-footer__social-link"
                href={YOUTUBE_CHANNEL_VIDEOS_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <i className="bi bi-youtube" aria-hidden />
              </a>
              <a className="site-footer__social-link" href="mailto:inbound@sbr2th.com" aria-label="Email">
                <i className="bi bi-envelope-fill" aria-hidden />
              </a>
            </div>
          </Col>

          <Col lg={8} xl={9}>
            <Row className="site-footer__columns g-4">
              {footerColumns.map((column) => (
                <FooterColumn key={column.title} title={column.title} links={column.links} />
              ))}
            </Row>
          </Col>
        </Row>

        <div className="site-footer__bottom">
          <span>© {year} SBR2TH. All rights reserved.</span>
        </div>
      </Container>
    </footer>
  );
}
